/*
 *
 * GenericShopList
 *
 * @version 1.0.0
 * @author Alessandro Mancuso
 * @since 08-Oct-2025
*/

import SecondaryUserShopListModal from './SecondaryUserShopListModalContainer'

export default SecondaryUserShopListModal
